import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/draft-confirmation.scss';

Component('tr-draft-confirmation', {
  mixins: [eventListenerMixin],

  properties: {
    remote: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    const buttonEdit = this.querySelector('#button-edit');
    if (this.remote) {
      $(buttonEdit).on('ajax:success', () => this.namespacedTrigger('edit', { bubbles: true }));
    } else {
      this.listenTo(buttonEdit, 'click', () => this.namespacedTrigger('edit', { bubbles: true }));
    }

    const buttonDestroy = this.querySelector('#button-destroy');
    $(buttonDestroy).on('ajax:success', () => {
      this.remove();
      this.namespacedTrigger('destroy', { bubbles: true });
    });
  },

  disconnected() {
    this.stopListening();
  },
});
